import MenuItemScreen from './menu_item_screen'

export default MenuItemScreen
